import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { TYPES_COMMUNICATION } from '@eec/contrats';
import { requete } from '../../api/client';
import { messageErreur } from '../../api/erreurs';
import { CarteMessagesPublics } from './CarteMessagesPublics';
export function MessagesPublics() {
  const [demo, setDemo] = useState(false);
  const [province, setProvince] = useState('');
  const [domaine, setDomaine] = useState('');
  const q = useQuery({
    queryKey: ['messages-publics', demo, province, domaine],
    queryFn: () =>
      requete<{
        tronque: boolean;
        elements: {
          id: string;
          titre: string;
          contenu: string;
          organisation: string;
          province: string;
          province_code: string;
          domaine: string;
          type: keyof typeof TYPES_COMMUNICATION;
          fictive: boolean;
          debut: string | null;
          fin: string | null;
        }[];
      }>('/communication-reseau/publics', {
        parametres: {
          inclure_fictives: demo ? 'oui' : 'non',
          ...(province ? { province_code: province } : {}),
          ...(domaine ? { domaine } : {}),
        },
      }),
    staleTime: 0,
    refetchInterval: 60000,
  });
  return (
    <section aria-label="Informations des exploitants">
      <h2>Informations des exploitants</h2>
      <label>
        <input type="checkbox" checked={demo} onChange={(e) => setDemo(e.target.checked)} /> Inclure
        les messages de démonstration
      </label>
      <div className="eec-filtres">
        <label>
          Province des annonces
          <select
            aria-label="Province des annonces"
            value={province}
            onChange={(e) => setProvince(e.target.value)}
          >
            <option value="">Toutes les provinces</option>
            {[
              'Estuaire',
              'Haut-Ogooué',
              'Moyen-Ogooué',
              'Ngounié',
              'Nyanga',
              'Ogooué-Ivindo',
              'Ogooué-Lolo',
              'Ogooué-Maritime',
              'Woleu-Ntem',
            ].map((nom, i) => (
              <option key={nom} value={`G${i + 1}`}>
                {nom}
              </option>
            ))}
          </select>
        </label>
        <label>
          Service des annonces
          <select
            aria-label="Service des annonces"
            value={domaine}
            onChange={(e) => setDomaine(e.target.value)}
          >
            <option value="">Eau et électricité</option>
            <option value="WATER">Eau</option>
            <option value="ELECTRICITY">Électricité</option>
          </select>
        </label>
      </div>
      {q.error && <p role="alert">{messageErreur(q.error)}</p>}
      {q.isPending && <p>Chargement des informations…</p>}
      {q.data?.tronque && (
        <p role="alert">
          Les 100 annonces les plus récentes sont affichées. Affinez la province et le service. La
          carte est masquée pour éviter des totaux incomplets.
        </p>
      )}
      {q.data && !q.error && !q.data.tronque && q.data.elements.length > 0 && (
        <CarteMessagesPublics messages={q.data.elements} />
      )}
      {q.data?.elements.length === 0 && (
        <p>
          Aucun message public en cours dans les données disponibles. Cela ne signifie pas l’absence
          d’incident.
        </p>
      )}
      {q.data?.elements.map((m) => (
        <article key={m.id}>
          <h3>{m.titre}</h3>
          <p>
            {m.organisation} · {m.province} · {m.domaine === 'WATER' ? 'Eau' : 'Électricité'} ·{' '}
            {TYPES_COMMUNICATION[m.type]}
            {m.fictive ? ' · DÉMONSTRATION' : ''}
          </p>
          <p style={{ whiteSpace: 'pre-wrap' }}>{m.contenu}</p>
          {m.debut && <p>Début : {new Date(m.debut).toLocaleString('fr-FR')}</p>}
          {m.fin && <p>Fin : {new Date(m.fin).toLocaleString('fr-FR')}</p>}
        </article>
      ))}
    </section>
  );
}
